import { TailSpin } from "react-loader-spinner";
import ModalCompMainPage from "../../../pages/Main_page/ModalCompMainPage/ModalCompMainPage";
import { memo, useState } from "react";
import { handelVacatinTypeShow, vacationStatusCheck } from '../../../libs/generalFunctions';

import "./vacationStatusShow.scss";

function VacationStatusShow({ loading , vacationData }) {

//====State start here====
//to try to make a modal
const [modalIsOpen, setIsOpen] = useState(false);

const [modalData,setModalData] = useState({});

//====State end here====

//====Event handler start here====
function openModal(obj) {
    setModalData(obj)
    setIsOpen(true);
  }

function closeModal() {
   setIsOpen(false);
  }

//====Event handler end here====

  return (
<div className='checkForTheVacationsStatus_section'>

    { ( loading ) ? (
        <>
        <div className='checkForTheVacationsStatus_section_loading'>
        <TailSpin
          visible={true}
          height="26"
          width="26"
          color="rgba(52,144,220,255)"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
        />
        <span dir='rtl' style={{color:"black" , marginRight:".4rem"}}>يتم التحقق من حالة الاجازات...</span>
        </div>
        </>
      )
      :( <></> )
      }



    {
        ( vacationData.length > 0 ) &&
        (
            <table >
            <thead>
            <tr >
            <th>تفاصيل</th>
            <th>حالة الطلب</th>
            <th>الاجازة</th>
           </tr>
           </thead>
          
          
           <tbody >
          
          { vacationData?.map(
              (item,index) =>(
               <tr key={index} >
              <td dir="rtl">
                <div className='btn_for_VacaMoreDetails_cover'>
                <button className='btn_for_VacaMoreDetails' onClick={()=>{openModal(item)}}>اضغط</button>
                </div></td>  
             <td dir="rtl">{item.status && vacationStatusCheck(item.status)}</td>
             <td dir="rtl">{item.type && handelVacatinTypeShow(item.type)}</td>
          </tr>
      
          )
            )}
                    
          </tbody>
          
          </table>
        )
    }


    <ModalCompMainPage isOpen={modalIsOpen} closeFun={closeModal} data={modalData}/>


</div>
  )
}

export default memo(VacationStatusShow);